<template>
  <div class="box">
    <div class="top">
      <span>项目启动成功</span>
      <a-button type="primary" class="done" size="large" @click="$router.push({path:'/pad/index'})">
        完成
      </a-button>
    </div>
    <div class="img">
      <img src="@assets/project-started.png" />
    </div>
    <div class="botton">
      <a-button type="primary" class="btn" @click="f1">
        录入受试者
      </a-button>
      <!-- <span>已选择预实验，点击这里可直接开启</span> -->
    </div>
  </div>
</template>

<script>

export default {
  name: 'ProjectStartedSuccessfully',
  methods: {
    f1() {
      this.$router.push(`/pad/patient?projectId=${this.$route.query.id}`);
    }
  }
}
</script>

<style scoped lang="less">
.box {
  overflow: hidden;
  height: 100vh;
  background: url(~@/assets/bg01.png) no-repeat center center;
  background-size: cover;

  .top {
    position: relative;
    text-align: center;

    span {
      display: block;
      font-size: 18px;
      color: white;
      padding: 40px 0;
    }

    .done {
      position: absolute;
      right: 20px;
      top: 50%;
      transform: translateY(-50%);
      background: #376EFF;
      border: 0;
      padding: 0 20px;
    }
  }

  .img {
    text-align: center;
    padding: 50px 0;
  }

  .botton {
    overflow: hidden;
    text-align: center;

    span {
      display: block;
      font-size: 14px;
      color: rgba(255, 255, 255, 0.70);
      margin-top: 10px;
    }

    .btn {
      padding: 0 150px;
      color: white;
      background: linear-gradient(90deg, #376EFF 0%, #DE5DFE 100%);
      border: none;
      border-radius: 21px;
    }

    /deep/ .ant-btn {
      height: 48px
    }
  }

}
</style>
